import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Row, Text, Panel, EmptyState, DealMenu, Money, Tag } from '../ui';
import { api } from '../api/client';

export function ArchivedDealsPanel({ kind }: { kind: 'archived' | 'deleted' }) {
  const [deals, setDeals] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(() => {
    const fetcher = kind === 'archived' ? api.dealsArchived : api.dealsTrashed;
    fetcher().then(r => setDeals(r.deals)).catch(() => setDeals([])).finally(() => setLoaded(true));
  }, [kind]);

  useEffect(() => { if (open && !loaded) refresh(); }, [open, loaded, refresh]);

  const title = kind === 'archived' ? 'Archived deals' : 'Deleted deals';
  const hint = kind === 'archived'
    ? 'Deals you have archived. Hidden from default lists. Restore at any time.'
    : 'Deals you have moved to trash. Restore to bring back, or permanently delete forever.';

  return (
    <Panel
      title={title}
      action={
        <button onClick={() => setOpen(o => !o)} className="text-xs text-muted hover:text-ink">
          {open ? 'collapse' : `show${loaded ? ` (${deals.length})` : ''}`}
        </button>
      }
    >
      {open && (
        <Stack gap={2}>
          <Text variant="label" muted>{hint}</Text>
          {!loaded ? <Text variant="label">loading...</Text>
            : deals.length === 0 ? <EmptyState title={`no ${kind} deals`} />
            : <Stack gap={1}>
                {deals.map((d: any) => (
                  <div key={d.id} className="hairline rounded-sm p-2 flex items-center gap-2">
                    <Link to={`/deals/${d.id}`} className="flex-1 min-w-0">
                      <Row justify="between" align="center" wrap>
                        <Stack gap={0.5}>
                          <Text variant="small" className="font-medium truncate">{d.name}</Text>
                          <Row gap={2}>
                            {d.sector && <Tag>{d.sector}</Tag>}
                            {kind === 'archived' && d.archivedAt && <Text variant="label" muted>archived {new Date(d.archivedAt).toLocaleDateString()}</Text>}
                            {kind === 'deleted' && d.deletedAt && <Text variant="label" muted>deleted {new Date(d.deletedAt).toLocaleDateString()}</Text>}
                          </Row>
                        </Stack>
                        {d.ticketSize && <Money amount={d.ticketSize} currency={d.currency || 'USD'} className="text-xs" />}
                      </Row>
                    </Link>
                    <DealMenu dealId={d.id} state={kind} onChange={refresh} />
                  </div>
                ))}
              </Stack>}
        </Stack>
      )}
    </Panel>
  );
}
